// publicFeaturedProductItem.action
import axios from "../helpers/axios";
import { publicFeaturedProductItemConstants as P } from './constants';

export const getPublicFeaturedProductItemByType = (type, random = "false") => {
    return async (dispatch) => {
        try {
            dispatch({
                type: P.GET_PUBLIC_FEATURED_PRODUCT_ITEM_REQUEST
            });

            const res = await axios.get(`/featuredProductItem/public/type/${type}/${random}`);

            if (res.status === 200) {
                dispatch({
                    type: P.GET_PUBLIC_FEATURED_PRODUCT_ITEM_SUCCESS,
                    payload: res.data
                });

                return res.data;
            }

            dispatch({
                type: P.GET_PUBLIC_FEATURED_PRODUCT_ITEM_FAILURE,
                payload: res.data
            });

            return null;
        } catch (error) {
            dispatch({
                type: P.GET_PUBLIC_FEATURED_PRODUCT_ITEM_FAILURE,
                payload: error?.response?.data || {
                    message: "Ошибка получения публичного списка товаров"
                }
            });

            return null;
        }
    };
};

export const resetPublicFeaturedProductItem = () => ({
    type: P.RESET_PUBLIC_FEATURED_PRODUCT_ITEM
});